const tokenTypes = Object.freeze({
  WITHDRAWAL: "WITHDRAWAL",
  TRANSFER: "TRANSFER",
});

export default tokenTypes;
